export const popupType = state => state.popupType;
export const popupResolve = state => state.popupResolve;
export const popupReject = state => state.popupReject;
export const popupData = state => state.popupData;
